/*
 * @Author: WangChao
 * @Date: 2025-12-18 21:05:03
 * @LastEditors: WangChao
 * @LastEditTime: 2026-08-10 11:17:08
 * @FilePath: \travel_ai\src\lib\api.js
 * @Description:
 */
module.exports = {
  newTest: {
    // 新机票订单查询
    airTest: "/orderApi/getOrderInfo",
    flightDetail: "/order/getFlightOrderByOrderId",
    hotelDetail: "/HotelOrder/Detail",
    inFlightDetail: "/international/flight/orderApi/getOrderDetail",
    inHotelDetail: "/iorder/orderDetail",
    carDetail: "/car/api/order/get",
    orderDetail: "/ykb_train/getOrderCostDetail",
    insuranceList: "/insurance/getOrderList",
    insuranceDetail: "/insurance/carrying/getBindInsOrderList",
  },
  chat: {
    ssoLogin: "/travelThirdparty/travel-third-party/public/login",
    searchCompany: "/reportDown/searchCompany",
    getHunterHotel: "/travelThirdparty/travel-third-party/hotel/hotelHunterInquiryQuery",
    checkLinkBroken: "/travelThirdparty/travel-third-party/public/getLinkBroken",
    hotelStandard: "/api/order/check.standard.ai",
    hotelReason: "/api/order/reasons.ai",
    hotelServiceFee: "api/order/free.ai",
    getAiHotel: "/api/hotel/hotel.ai",
    getAiHoteRate: "api/hotel/hotel.ai.rate",
  }
};
